import { FocusEvent } from "react";

export const handleFocus = (event: FocusEvent<HTMLInputElement>) => {
    event?.target?.select();
};
